import {
    useDocsI18n
} from "../i18n";
import type {
    DocsTocItem
} from "../components/toc";
import {
    PageHeader,
    BulletList,
    Article,
    Section,
    Cards,
    Stats
} from "../components/content";
import {
    COMPONENT_GROUP_COUNT,
    COMPONENT_COUNT
} from "../nav";
import TokenPlant from "../figures/tokenPlant";

export const getIntroductionToc = (t: (key: string) => string): Array<DocsTocItem> => [
    {
        title: t("intro.whyTitle"),
        id: "why"
    },
    {
        title: t("intro.numbersTitle"),
        id: "numbers"
    },
    {
        title: t("intro.startTitle"),
        id: "start"
    }
];

const IntroductionPage = () => {
    const {
        t
    } = useDocsI18n();

    return <Article>
        <PageHeader
            breadcrumbs={[
                {
                    label: t("breadcrumb.docs")
                }
            ]}
            lead={t("intro.lead")}
            title="NCore UI Kit"
        />
        <TokenPlant />
        <Section
            title={t("intro.whyTitle")}
            id="why"
        >
            <BulletList
                items={[
                    t("intro.why1"),
                    t("intro.why2"),
                    t("intro.why3"),
                    t("intro.why4"),
                    t("intro.why5")
                ]}
            />
        </Section>
        <Section
            title={t("intro.numbersTitle")}
            id="numbers"
        >
            <Stats
                items={[
                    {
                        label: t("intro.statComponents"),
                        value: String(COMPONENT_COUNT)
                    },
                    {
                        value: String(COMPONENT_GROUP_COUNT),
                        label: t("intro.statGroups")
                    },
                    {
                        label: t("intro.statPalettes"),
                        value: "3"
                    },
                    {
                        label: t("intro.statLocales"),
                        value: "2"
                    }
                ]}
            />
        </Section>
        <Section
            title={t("intro.startTitle")}
            id="start"
        >
            <Cards
                items={[
                    {
                        title: t("intro.cardInstallTitle"),
                        text: t("intro.cardInstallText"),
                        href: "/installation"
                    },
                    {
                        title: t("intro.cardThemeTitle"),
                        text: t("intro.cardThemeText"),
                        href: "/theming"
                    },
                    {
                        title: t("intro.cardComponentsTitle"),
                        text: t("intro.cardComponentsText", [
                            COMPONENT_COUNT,
                            COMPONENT_GROUP_COUNT
                        ]),
                        href: "/components/switch"
                    },
                    {
                        title: t("intro.cardExampleTitle"),
                        text: t("intro.cardExampleText"),
                        href: "http://localhost:3000/",
                        isExternal: true
                    }
                ]}
            />
        </Section>
    </Article>;
};
export default IntroductionPage;
